import { useState } from 'react';

import { useModal } from '@hooks';
import { JsonView, Modal } from '@components';

type UseViewParams = {
  title?: string;
};

export const useView = ({ title = 'Preview' }: UseViewParams = {}) => {
  const [value, setValue] = useState<object>({});
  const { isOpened, onOpen, onClose } = useModal();

  const handleView = (object: Object) => {
    // alert(JSON.stringify(object, null, 2));
    setValue(object);
    onOpen();
  };
  const handleClose = () => {
    onClose();
    setValue({});
  };

  return {
    element: (
      <Modal title={title} open={isOpened} onClose={handleClose}>
        <JsonView value={value} />
      </Modal>
    ),
    handleView,
  };
};
